import React from "react";
import { recheckStatus } from "../lib/reminders";
import { CalendarClock, AlertTriangle, CheckCircle2 } from "lucide-react";

const TONE = {
  "on-track": {
    bg: "bg-success/10",
    text: "text-[#3f6a52]",
    icon: <CheckCircle2 size={18} />,
    label: "On track",
  },
  "due-soon": {
    bg: "bg-warning/10",
    text: "text-[#8a5a2b]",
    icon: <CalendarClock size={18} />,
    label: "Due soon",
  },
  due: {
    bg: "bg-warning/20",
    text: "text-[#8a5a2b]",
    icon: <CalendarClock size={18} />,
    label: "Due now",
  },
  overdue: {
    bg: "bg-destructive/10",
    text: "text-destructive",
    icon: <AlertTriangle size={18} />,
    label: "Overdue",
  },
};

export default function RecheckReminder({ iris, labs }) {
  if (!iris?.ready || !labs?.length) return null;
  const latestLabDate = [...labs].sort((a, b) => a.date.localeCompare(b.date)).slice(-1)[0]?.date;
  const info = recheckStatus(latestLabDate, iris.stage);
  if (!info) return null;

  const tone = TONE[info.status];

  const message = (() => {
    if (info.status === "overdue")
      return `Recheck is overdue by ${Math.abs(info.daysUntilDue)} days. IRIS Stage ${iris.stage} recommends rechecks ${info.cadenceLabel}.`;
    if (info.status === "due")
      return `Recheck is due now. Last labs were ${info.daysSinceLast} days ago; Stage ${iris.stage} recommends ${info.cadenceLabel}.`;
    if (info.status === "due-soon")
      return `Recheck due in ${info.daysUntilDue} days (${info.dueDate}). Stage ${iris.stage} recommends ${info.cadenceLabel}.`;
    return `Next recheck around ${info.dueDate} (in ${info.daysUntilDue} days). Stage ${iris.stage} recommends ${info.cadenceLabel}.`;
  })();

  return (
    <div className={`card-soft p-5 ${tone.bg} flex items-start gap-3`} data-testid="recheck-reminder">
      <div className={`w-10 h-10 rounded-full bg-background flex items-center justify-center ${tone.text}`}>
        {tone.icon}
      </div>
      <div className="flex-1">
        <div className={`text-xs uppercase tracking-wide font-medium ${tone.text}`} data-testid="recheck-status-label">
          {tone.label}
        </div>
        <div className="text-sm text-foreground/85 mt-1 leading-relaxed">{message}</div>
      </div>
    </div>
  );
}
